// Type imports
import type React from 'react'
import type { BaseLocalizedProps } from './types'

// External imports
import styled from '@emotion/styled'

import FiveStars from '../FiveStars'

const Container = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
`

const Text = styled.p`
  margin-left: 10px;
  font-weight: 700;
`

const EdgeStoreRating: React.FC<BaseLocalizedProps> = ({ t, tOptions }) => {
  return (
    <Container>
      <FiveStars />
      <Text>{t('EDGE_EXT_STORE', tOptions)}</Text>
    </Container>
  )
}

export default EdgeStoreRating
